import {couponAvailable,DetailCoupon} from './couponPresentation'
import {validWebActivity} from './activityCoupon'

export type ReceivedCoupon=DetailCoupon & {id?:number}
export interface CouponReceiptScope {orgId:number;customerId:number}
export function couponReceiptIdentity(ready:boolean,token:any,user:any,orgId:any,verifiedOrgId:any):string {
  const org=Number(orgId),id=Number(user?.id)
  return ready && Boolean(token) && Number.isSafeInteger(org) && org>=1000 && Number(verifiedOrgId)===org
    && Number.isSafeInteger(id) && id>0 && Number(user?.orgId)===org ? JSON.stringify([token,org,id]) : ''
}
export const couponReceiptKey=(scope:CouponReceiptScope,id:number)=>`coupon-received:web:${scope.orgId}:${scope.customerId}:${id}`
// 已提醒按账号、店铺、端和券实例保存；不改变全账号共用的券已读状态。
export function createCouponReceiptTracker(){
  const session=new Set<string>()
  const seen=(scope:CouponReceiptScope,id:number,read:(key:string)=>any)=>{
    const key=couponReceiptKey(scope,id)
    if(session.has(key))return true
    try{return read(key)==='1'}catch{return false}
  }
  return {
    unseen(notes:ReceivedCoupon[],scope:CouponReceiptScope,read:(key:string)=>any,now=Date.now()):ReceivedCoupon[]{
      const ids=new Set<number>()
      return (Array.isArray(notes)?notes:[]).filter(note=>{
        const id=Number(note?.customerNoteId)
        if(!couponAvailable(note,now) || ![1000,scope.orgId].includes(Number(note.orgId)) || ids.has(id) || seen(scope,id,read))return false
        ids.add(id);return true
      }).sort((a,b)=>Number(a.customerNoteId)-Number(b.customerNoteId))
    },
    remember(notes:ReceivedCoupon[],scope:CouponReceiptScope,read:(key:string)=>any,write:(key:string,value:string)=>void):boolean {
      if(!notes.length || notes.some(note=>!couponAvailable(note) || seen(scope,Number(note.customerNoteId),read)))return false
      for(const note of notes){
        const key=couponReceiptKey(scope,Number(note.customerNoteId));session.add(key)
        try{write(key,'1')}catch{/* 禁止持久存储时仍在当前会话内去重。 */}
      }
      return true
    }
  }
}
export function receiptActivity(configuration:any,notes:ReceivedCoupon[],orgId:number,now=Date.now()):any|null {
  const campaigns=Array.isArray(configuration)?configuration:[configuration]
  return campaigns.find(config=>Number(config?.orgId)===orgId && config?.mode==='coupon' && validWebActivity(config,now)
    && notes.some(note=>Number(note.id)===Number(config.couponId) && Number(note.orgId)===orgId)) || null
}
export function couponReceiptSafePath(path:string):boolean {
  return !/pay|orderconfirm|upgrade|deposite|login|request|upload|edit|makingboke|autoscale|[/]add/i.test(path)
}
